import React, { forwardRef, useImperativeHandle, useState } from 'react';
import ReactDOM from 'react-dom'
import FloatingLayerPublic from '../FloatingLayerPublic';



const PublicMessageInLayer = forwardRef((props, ref) => {

    const [display,setDisplay] = useState(false);

    useImperativeHandle(ref, () => ({
		toggle () {
            toggleState();
        }
	}), []);
    

    const toggleState = ()=>{
       setDisplay(!display);
    }
    if (!display) return null;

	return (
		<FloatingLayerPublic
			pm={props.promotion}
			backButton={toggleState}
			title={`<h1>${props.title}</h1>`}
		>
			{props.children}
		</FloatingLayerPublic>
	);
})

export default (PublicMessageInLayer);